import { render } from "./XGiz.vue?vue&type=template&id=924fa3ee"
import script from "./XGiz.vue?vue&type=script&lang=js"
export * from "./XGiz.vue?vue&type=script&lang=js"

import "./XGiz.vue?vue&type=style&index=0&id=924fa3ee&lang=scss"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__